import "bootstrap/scss/_modal.scss";
import "bootstrap/js/dist/modal";
import "./_crunch-modal-styles.scss";
import "./crunch-modal-scripts";
